import { __decorate } from "tslib";
import Component from 'vue-class-component';
import authService from "@/services/authService";
import ReactiveComponent from "@/components/ReactiveComponent";
import StringUtils from "@/utils/stringUtils";
let TemplateHeader = class TemplateHeader extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.displayName = '';
        this.picture = '';
        this.avatarLetter = '';
        this.hasPicture = false;
    }
    created() {
        this.subscribe('user', authService.user, (user) => {
            this.displayName = user.displayName || '';
            this.avatarLetter = StringUtils.isNotBlank(this.displayName) ? this.displayName.charAt(0).toUpperCase() : '';
            this.picture = user.photoURL || '';
            this.hasPicture = StringUtils.isNotBlank(this.picture);
        });
    }
    logout() {
        this.subscribe('logout', authService.logout(), () => {
        });
    }
};
TemplateHeader = __decorate([
    Component({})
], TemplateHeader);
export default TemplateHeader;
